import { render, staticRenderFns } from "./listPeople.vue?vue&type=template&id=5ca0c672&scoped=true&"
import script from "./listPeople.vue?vue&type=script&lang=js&"
export * from "./listPeople.vue?vue&type=script&lang=js&"
import style0 from "./listPeople.vue?vue&type=style&index=0&id=5ca0c672&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0c672",
  null
  
)

export default component.exports